<template>
	<b-button-group
		id="shape-authoring-toolbar"
		:draggable="dragState.draggable"
		:style="toolbarStyle"
		:vertical="vertical"
		class="bg-dark"
		@dragstart="beginToolbarDrag"
		@drag="onDrag"
		@dragend.prevent="dragState.draggable=false"
	>
		<b-button
			tabindex="-1"
			size="sm"
			variant="secondary"
			@click.stop="vertical=!vertical"
			@mousedown="dragState.draggable=true"
		>
			<b-icon icon="arrows-move" />
		</b-button>
		<b-button
			v-b-tooltip.hover
			tabindex="-1"
			:title="$t('shape-authoring-workflow.toolbar.undo')"
			:disabled="!undoEnabled"
			size="sm"
			variant="secondary"
			@click.stop="$emit('undo')"
		>
			<b-icon icon="arrow-counterclockwise" />
		</b-button>
		<b-button
			v-b-tooltip.hover
			tabindex="-1"
			:title="$t('shape-authoring-workflow.toolbar.redo')"
			:disabled="!redoEnabled"
			size="sm"
			variant="secondary"
			@click.stop="$emit('redo')"
		>
			<b-icon icon="arrow-clockwise" />
		</b-button>
		<!-- b-button
			v-b-tooltip.hover
			tabindex="-1"
			:title="$t('shape-authoring-workflow.toolbar.toggle-grid')"
			size="sm"
			variant="secondary"
			@click.stop="$emit('toggle-grid')"
		>
			<b-icon icon="grid3x3" />
		</b-button -->
		<b-button
			v-b-tooltip.hover
			tabindex="-1"
			:title="$t('shape-authoring-workflow.toolbar.cancel')"
			size="sm"
			variant="dark"
			@click.stop="$emit('exit', false)"
		>
			<b-icon icon="x" />
		</b-button>
		<b-button
			v-show="completable"
			v-b-tooltip.hover
			tabindex="-1"
			:title="$t('shape-authoring-workflow.toolbar.confirm')"
			size="sm"
			variant="success"
			@click.stop="$emit('exit', true)"
		>
			<b-icon icon="check" />
		</b-button>
	</b-button-group>
</template>

<script>
const transparentPixel = new Image();
transparentPixel.src = 'data:image/gif;base64,R0lGODlhAQABAIAAAAUEBAAAACwAAAAAAQABAAACAkQBADs=';

export default {
	name: 'ShapeAuthoringToolbar',
	props: {
		/**
		 * Enables compelte button in toolbar
		 */
		completable: {
			type: Boolean,
			default: false,
		},
		/**
		 * Number of history items available
		 */
		undoEnabled: {
			type: Boolean,
			default: false,
		},
		/**
		 * Current position in the history stack
		 */
		redoEnabled: {
			type: Boolean,
			default: false,
		},
		/**
		 * The element restricting toolbar movement, required
		 */
		container: {
			type: Element,
			default: null,
			// setting required to true causes a nasty warning due to it being initialized to null before the actual element exists
			// required: true,
		},
	},
	data() {
		return {
			vertical: window.innerWidth < window.innerHeight,
			dragState: {
				draggable: false,
				offsetX: 0,
				offsetY: 0,
				toolbarRect: null,
				containerRect: null,
			},
			toolbarStyle: {
				left: 0,
				top: 0,
			},
		};
	},
	computed: {},
	mounted() {},
	methods: {
		positionAtOrigin() {
			const parentBR = this.container.getBoundingClientRect();
			const ourBR = this.$el.getBoundingClientRect();
			this.toolbarStyle.left = `${parentBR.width / 2 - ourBR.width / 2}px`;
			this.toolbarStyle.top = '4rem';
		},
		beginToolbarDrag(e) {
			const { offsetX, offsetY } = e;
			this.dragState.offsetX = offsetX;
			this.dragState.offsetY = offsetY;
			this.dragState.toolbarRect = this.$el.getBoundingClientRect();
			this.dragState.containerRect = this.container.getBoundingClientRect();
			e.dataTransfer.setDragImage(transparentPixel, 0, 0);
		},
		onDrag(e) {
			if (e.clientX <= 0 || e.clientY <= 0) return;
			const left = Math.max(
				0,
				Math.min(
					e.clientX - this.dragState.containerRect.left - this.dragState.offsetX,
					this.dragState.containerRect.width - this.dragState.toolbarRect.width
				)
			);
			const top = Math.max(
				0,
				Math.min(
					e.clientY - this.dragState.containerRect.top - this.dragState.offsetY,
					this.dragState.containerRect.height - this.dragState.toolbarRect.height
				)
			);
			this.toolbarStyle.left = `${left}px`;
			this.toolbarStyle.top = `${top}px`;
		},
	},
};
</script>

<style lang="scss" scoped>
#shape-authoring-toolbar {
	white-space: nowrap;
	transition: none;
	position: absolute;
	display: inline-block;
	z-index: 10;
	box-shadow: 0 0 0.5rem #000;
	& > button {
		border: none;
		margin: 0;
		&:focus {
			box-shadow: none !important;
		}
	}
	&.btn-group-vertical button {
		display: block !important;
	}
}
</style>
